var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: "F/T Apply", isShowFollow: false },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { rules: _vm.rules, model: _vm.form } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "applyNo",
                                  label: _vm.$t("home.applyNo"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.applyNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "applyNo", $$v)
                                    },
                                    expression: "form.applyNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "agreementNo",
                                  label: _vm.$t("home.agreementNoOne"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.agreementNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "agreementNo", $$v)
                                    },
                                    expression: "form.agreementNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "blNo",
                                  label: _vm.$t("home.blNo"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.blNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "blNo", $$v)
                                    },
                                    expression: "form.blNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "approvedNo",
                                  label: _vm.$t("home.approvedNo"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.approvedNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "approvedNo", $$v)
                                    },
                                    expression: "form.approvedNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "isAccepted",
                                  label: _vm.$t("home.ftIsAccepted"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: "", clearable: "" },
                                    model: {
                                      value: _vm.form.isAccepted,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "isAccepted", $$v)
                                      },
                                      expression: "form.isAccepted",
                                    },
                                  },
                                  _vm._l(_vm.isAcceptedList, function (item) {
                                    return _c("el-option", {
                                      key: item.codeValue,
                                      attrs: {
                                        label:
                                          _vm.language === "zh"
                                            ? item.displayValueCn
                                            : item.displayValue,
                                        value: Number(item.codeValue),
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "vesselAndVoyage",
                                  label: _vm.$t("home.vesselAndVoyage"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.vesselAndVoyage,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "vesselAndVoyage", $$v)
                                    },
                                    expression: "form.vesselAndVoyage",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "etd", label: "ETD" } },
                              [
                                _c("el-date-picker", {
                                  attrs: { disabled: "", type: "date" },
                                  model: {
                                    value: _vm.form.etd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "etd", $$v)
                                    },
                                    expression: "form.etd",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "eta", label: "ETA" } },
                              [
                                _c("el-date-picker", {
                                  attrs: { disabled: "", type: "date" },
                                  model: {
                                    value: _vm.form.eta,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "eta", $$v)
                                    },
                                    expression: "form.eta",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "por",
                                  label: _vm.$t("home.receipt"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.por,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "por", $$v)
                                    },
                                    expression: "form.por",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "pol",
                                  label: _vm.$t("home.pol"),
                                },
                              },
                              [
                                _c("glPort", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.pol,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "pol", $$v)
                                    },
                                    expression: "form.pol",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "pod",
                                  label: _vm.$t("home.pod"),
                                },
                              },
                              [
                                _c("glPort", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.pod,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "pod", $$v)
                                    },
                                    expression: "form.pod",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "del",
                                  label: _vm.$t("home.destination"),
                                },
                              },
                              [
                                _c("glPort", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.del,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "del", $$v)
                                    },
                                    expression: "form.del",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "commodity",
                                  label: _vm.$t("home.commodity"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    disabled: _vm.form.isAccepted === 1,
                                  },
                                  model: {
                                    value: _vm.form.commodity,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "commodity", $$v)
                                    },
                                    expression: "form.commodity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "containerVolume",
                                  label: _vm.$t("home.containerVolumeOne"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.containerVolume,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "containerVolume", $$v)
                                    },
                                    expression: "form.containerVolume",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "teus", label: "Teus" } },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.teus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "teus", $$v)
                                    },
                                    expression: "form.teus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "applyReason",
                                  label: _vm.$t("home.applyReason"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    disabled: _vm.form.isAccepted === 1,
                                  },
                                  model: {
                                    value: _vm.form.applyReason,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "applyReason", $$v)
                                    },
                                    expression: "form.applyReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "expectedDeliveryTime",
                                  label: _vm.$t("home.expectedDeliveryTime"),
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: _vm.form.isAccepted === 1,
                                    type: "date",
                                  },
                                  model: {
                                    value: _vm.form.expectedDeliveryTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "expectedDeliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "form.expectedDeliveryTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 20 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "shipperName",
                                  label: _vm.$t("home.shipperName"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.shipperName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "shipperName", $$v)
                                    },
                                    expression: "form.shipperName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 20 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "consigneeName",
                                  label: _vm.$t("home.consigneeName"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.consigneeName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "consigneeName", $$v)
                                    },
                                    expression: "form.consigneeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-row",
                          {
                            staticStyle: { width: "40%" },
                            attrs: { gutter: 10 },
                          },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 15 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "isDG",
                                      label: _vm.$t("home.isDG"),
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: "", clearable: "" },
                                        model: {
                                          value: _vm.form.isDg,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "isDg", $$v)
                                          },
                                          expression: "form.isDg",
                                        },
                                      },
                                      _vm._l(_vm.isDgList, function (item) {
                                        return _c("el-option", {
                                          key: item.codeValue,
                                          attrs: {
                                            label:
                                              _vm.language === "zh"
                                                ? item.displayValueCn
                                                : item.displayValue,
                                            value: Number(item.codeValue),
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "rfPlugDays",
                                      label: _vm.$t("home.rfPlugDays"),
                                    },
                                  },
                                  [
                                    _c("el-input-number", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                        { name: "trim", rawName: "v-trim" },
                                        { name: "fth", rawName: "v-fth" },
                                      ],
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        disabled: _vm.form.isAccepted === 1,
                                        max: 9999,
                                      },
                                      model: {
                                        value: _vm.form.rfPlugDays,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "rfPlugDays", $$v)
                                        },
                                        expression: "form.rfPlugDays",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "table-container-new",
                            staticStyle: { width: "45%" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                ref: "singleTable",
                                attrs: {
                                  data: _vm.mktFrtContainerVos,
                                  "highlight-current-row": "",
                                },
                                on: {
                                  "current-change": _vm.handleCurrentChange,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "containerType",
                                    label: _vm.$t("home.containerTypeCode"),
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                staticStyle: {
                                                  "pointer-events": "none",
                                                },
                                                attrs: {
                                                  disabled: "",
                                                  maxlength: "50",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.containerType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "containerType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.containerType",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "containerNo",
                                    label: _vm.$t("home.containerNo"),
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("el-input", {
                                                staticStyle: {
                                                  "pointer-events": "none",
                                                },
                                                attrs: {
                                                  disabled: "",
                                                  maxlength: "50",
                                                },
                                                model: {
                                                  value: scope.row.containerNo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "containerNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.containerNo",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "cargoType",
                                    label: _vm.$t("home.cargoTypeCodeOne"),
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c("glCargoGoods", {
                                                staticStyle: {
                                                  "pointer-events": "none",
                                                },
                                                attrs: { disabled: "" },
                                                model: {
                                                  value: scope.row.cargoType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "cargoType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.cargoType",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.validateNull(this.currentRow) ||
                                        (_vm.mktFrtContainerVos &&
                                          _vm.mktFrtContainerVos.length === 1),
                                    },
                                    on: { click: _vm.handleDelete },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c("div", [_vm._v("DEMURRAGE")]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "demuFreeDays",
                                  label:
                                    _vm.$t("home.demuFreeDays") +
                                    "" +
                                    " FREE  DAYS",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    disabled: _vm.form.isAccepted === 1,
                                  },
                                  model: {
                                    value: _vm.form.demuFreeDays,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "demuFreeDays", $$v)
                                    },
                                    expression: "form.demuFreeDays",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c("div", [_vm._v("DETENTION")]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "detenFreeDays",
                                  label:
                                    _vm.$t("home.detenFreeDays") +
                                    "" +
                                    " FREE  DAYS",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    disabled: _vm.form.isAccepted === 1,
                                  },
                                  model: {
                                    value: _vm.form.detenFreeDays,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "detenFreeDays", $$v)
                                    },
                                    expression: "form.detenFreeDays",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.pol === "CNSHK" || _vm.pol === "CNNSA"
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "430px",
                          "white-space": "pre-wrap",
                          "word-break": "keep-all",
                          "margin-top": "20px",
                          "word-spacing": "2px",
                          "line-height": "16px",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("home.applicationRules")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      margin: "20px 0 0px 0",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-primary",
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: {
                          disabled:
                            _vm.form.isAccepted === 1 ||
                            _vm.form.isAccepted === 2 ||
                            _vm.form.isAccepted === 3,
                          type: "primary",
                          plain: "",
                        },
                        on: { click: _vm.handleSubimtDoApplyFt },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("home.applyBooking")) + "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.form.isAccepted == "01"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.handleSubimtDraft },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("home.backCaoga")) + "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.isAccepted == "01" ||
                    _vm.form.isAccepted == "51" ||
                    !_vm.form.isAccepted
                      ? _c(
                          "el-button",
                          {
                            staticClass: "btn-info-primary",
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.handleButtonClose },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("home.buttonClose")) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }